import React from 'react';
import styles from './O_CapsuleReactionsHeader.module.css';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import M_SelectPicker from '@/components/M_Molecules/M_SelectPicker/M_SelectPicker';
import { O_CapsuleReactionsHeaderProps } from './types';

export default function O_CapsuleReactionsHeaderMobile({
  onBack,
  onExpand,
  isExpanded,
  showExpandButton = true,
  onOpenPostMenu,
  showPostMenuButton = false,
  viewOptions,
  selectedViewOption,
  onViewSelect,
}: O_CapsuleReactionsHeaderProps) {
  const shouldShowSwitcher =
    Boolean(viewOptions?.length) &&
    Boolean(selectedViewOption) &&
    Boolean(onViewSelect);

  return (
    <header className={styles.wrapper}>
      <A_CircleButton
        icon={
          <Q_Icon.ArrowLeftIcon
            width={8}
            height={16}
            stroke='currentColor'
            fill='none'
          />
        }
        size='small'
        onClick={onBack}
        variant='secondary'
      />
      <div className={styles.center_wrapper}>
        {shouldShowSwitcher && (
          <M_SelectPicker
            options={viewOptions || []}
            selectedOption={selectedViewOption || ''}
            onSelect={option => {
              onViewSelect?.(option);
            }}
            background='white'
          />
        )}
      </div>
      {showPostMenuButton ? (
        <A_CircleButton
          icon={<Q_Icon.InfoIcon width={3} height={14} fill='none' />}
          size='small'
          onClick={() => onOpenPostMenu?.()}
          variant='secondary'
        />
      ) : showExpandButton ? (
        <A_CircleButton
          icon={
            isExpanded ? (
              <Q_Icon.ReduceIcon width={24} height={24} fill='none' />
            ) : (
              <Q_Icon.ExpandIcon width={24} height={24} fill='none' />
            )
          }
          onClick={onExpand}
          variant='secondary'
        />
      ) : null}
    </header>
  );
}
